import { combineReducers } from 'redux';
import skinsReducer from './skinsSlice';
import templatesReducer from './templatesSlice';
import usersReducer from './usersSlice';
import commentsReducer from './commentsSlice';
import assetsReducer from './assetsSlice';
import categoriesReducer from './categoriesSlice';
import reportsReducer from './reportsSlice';

export default combineReducers({
  skins: skinsReducer,
  templates: templatesReducer,
  users: usersReducer,
  comments: commentsReducer,
  assets: assetsReducer,
  categories: categoriesReducer,
  reports: reportsReducer,
})
